module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-1-photo-10-8fe2f97388c83b14f8a51b162cf1f622.webp";